import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { dataPanel, panelType } from './customerRequest';
import { func } from '@/utils/public';
import exhibition from '@/views/system/customManage/exhibition.vue';
export default {
  components: {
    exhibition
  },
  data() {
    return {
      previewList: [],
      panelTypeList: [],
      activeKey: '',
      timer1: '',
      timer2: '',
      timer3: '',
      queryMethod: '',
      timeFrame: '',
      isSetTime: false,
      startTime: '',
      endTime: '',
      dateFrame: [],
      templateId: '',
      dateFrame0: {},
      dateFrame1: {},
      dateFrame2: {},
      dateFrame3: {},
      dateFrame4: {},
      isGetData: true,
      url: require('@/assets/vr/IMG_6408.png')
    };
  },
  created() {
    panelType().then(res => {
      if (res.length == 0) {
        return false;
      }
      this.panelTypeList = res;
      this.activeKey = res[0].key;
      this.getDataFun();
    });
  },
  methods: {
    getDataFun(num) {
      dataPanel({
        type: this.activeKey,
        queryMethod: this.queryMethod,
        timeFrame: this.timeFrame,
        startTime: this.startTime,
        endTime: this.endTime,
        templateId: this.templateId
      }).then(res => {
        this.isGetData = false;
        if (num || num == 0) {
          this.previewList.splice(num, 1, res);
          this.tabChange(this.activeKey, true);
          return false;
        } else if (res.length == 0) {
          return false;
        }
        const arr = res.sort(func) || [];
        let arr_new = [null, null, null, null, null];
        arr.map(item => {
          arr_new.splice(item.sort - 1, 1, item);
        });
        if (arr.length != 0) {
          this.queryMethod = arr[0].queryMethod;
          if (!this.isSetTime) {
            this.timeFrame = arr[0].timeFrame;
          }
        } else {
          this.queryMethod = '';
          this.timeFrame = '';
          this.startTime = '';
          this.endTime = '';
          this.templateId = '';
          this.dateFrame = [];
          this.dateFrame0 = {};
          this.dateFrame1 = {};
          this.dateFrame2 = {};
          this.dateFrame3 = {};
          this.dateFrame4 = {};
        }
        this.previewList = arr_new;
        this.tabChange(this.activeKey, true);
      });
    },
    tabChange(val, type) {
      if (this.isGetData) {
        return false;
      }
      this.activeKey = val;
      if (val == 1) {
        this.timer1 = new Date().getTime();
      } else if (val == 2) {
        this.timer2 = new Date().getTime();
      } else if (val == 3) {
        this.timer3 = new Date().getTime();
      }
      this.isSetTime = false;
      if (!type) {
        this.queryMethod = '';
        this.timeFrame = '';
        this.startTime = '';
        this.endTime = '';
        this.templateId = '';
        this.previewList = [];
        this.dateFrame = [];
        this.dateFrame0 = {};
        this.dateFrame1 = {};
        this.dateFrame2 = {};
        this.dateFrame3 = {};
        this.dateFrame4 = {};
        this.isGetData = true;
        setTimeout(() => {
          this.getDataFun();
        }, 400);
      }
    },
    setTmeFrameFun(val) {
      this.timeFrame = val;
      this.isSetTime = true;
      this.dateFrame = [];
      this.startTime = '';
      this.endTime = '';
      this.getDataFun();
    },
    setDateFrameFun(val) {
      console.log(val, 333);
      this.dateFrame = val;
      if (val.length) {
        this.timeFrame = '';
        this.startTime = val[0];
        this.endTime = val[1];
      } else {
        this.timeFrame = 'MONTH';
        this.startTime = '';
        this.endTime = '';
      }
      this.isSetTime = true;
      this.getDataFun();
    },
    setDateFrameSinglesFun(date, val, num) {
      console.log(5555);
      this.templateId = val.id;
      this.isSetTime = true;
      this['dateFrame' + num] = date;
      if (date.dateFrame.length != 0) {
        this.startTime = date.dateFrame[0];
        this.endTime = date.dateFrame[1];
        this.timeFrame = '';
      } else {
        this.timeFrame = date.timeFrame;
        this.startTime = '';
        this.endTime = '';
      }
      this.getDataFun(num);
    }
  }
};